<template>
        <full-screen-overlay @close="exit" backTo="Project">

            <div class="w-full h-full flex flex-col items-center justify-center text-center p-4">

                <typography variant="h4">Default payment method needed</typography>
                <typography variant="p" class="text-gray-600 mt-2 max-w-xl">This feature is only accessible if this project has a default payment method specified. Simply head to billing and scroll to the Payment Methods section.</typography>

                <form @submit.prevent="openBillingPortal" class="mt-6">
                        <base-button type="submit" icon="billing" iconPosition="left">
                        Head to Billing
                        </base-button>
                </form>

            </div>

        </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { authenticationState, loading, error, billing, currentProject } from '@/mixins';
import { updateAuthenticationState } from "@/graphql/mutations";

export default {
    name: "NeedsPaymentMethod",
    metaInfo: {
      title: 'Payment Method Needed',
    },
    mixins: [LayoutComponents, authenticationState, loading, error,billing, currentProject ],
    methods: {
        exit () {
            this.$router.push({ name: "Project", query: { ...this.$route.query } })
        }
    }
}
</script>